import { createSelector } from 'reselect'

export const toastStateSelector = state => state.toast

export const toastSelector = createSelector(
  toastStateSelector,
  state => state
)
